import { HttpRequestStatus } from 'model/enums/httpRequestStatus';
import { GetShareholderDocumentsActionTypes, GetShareholderDocumentsState } from 'reducer/shareholder/get-shareholder-documents/types';
import { Reducer } from 'redux';

export const initialState: GetShareholderDocumentsState = {
    status: HttpRequestStatus.NOOP,
    error: undefined,
    shareholderDocuments: undefined
};

const reducer: Reducer<GetShareholderDocumentsState> = (state = initialState, action): GetShareholderDocumentsState => {
    switch (action.type) {
        case GetShareholderDocumentsActionTypes.GET_SHAREHOLDER_DOCUMENTS_REQUEST: {
            return { ...state, status: HttpRequestStatus.ONGOING, shareholderDocuments: undefined, error: undefined };
        }
        case GetShareholderDocumentsActionTypes.GET_SHAREHOLDER_DOCUMENTS_SUCCESS: {
            return { ...state, status: HttpRequestStatus.SUCCESS, shareholderDocuments: action.payload, error: undefined };
        }
        case GetShareholderDocumentsActionTypes.GET_SHAREHOLDER_DOCUMENTS_ERROR: {
            return { ...state, status: HttpRequestStatus.ERROR, error: action.payload };
        }
        case GetShareholderDocumentsActionTypes.GET_SHAREHOLDER_DOCUMENTS_RESET_STATE: {
            return { ...initialState };
        }
        default: {
            return state;
        }
    }
};

export { reducer as getShareholderDocumentsReducer };
